// extracted by mini-css-extract-plugin
export default {"photo-wall":"PhotoWall_photo-wall__iQ2cJ","wrapper":"PhotoWall_wrapper__9vqxK","column":"PhotoWall_column__8xxSS","img":"PhotoWall_img__jYg7A"};